import {Injectable, OnDestroy, signal} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import {filter, Subscription} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LazyRouteLoadingService implements OnDestroy {
  readonly loading = signal(false);

  private subscription: Subscription;

  constructor(private router: Router) {
    this.subscription = this.router.events
      .pipe(
        filter(
          (event): event is
            | RouteConfigLoadStart
            | NavigationEnd
            | NavigationCancel
            | NavigationError =>
            event instanceof RouteConfigLoadStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
      )
      .subscribe((event) => {
        if (event instanceof RouteConfigLoadStart) {
          this.loading.set(true);
        } else {
          this.loading.set(false);
        }
      });
  }

  onMenuItemClick(url: string): void {
    if (this.isLazyRoute(url)) {
      this.loading.set(true);
    }
  }

  private isLazyRoute(url: string): boolean {
    const path = url.split('?')[0];

    if (path.startsWith('/dictionaries')) {
      return true;
    }

    if (path === '/electronic-field-map') {
      return true;
    }

    return path.startsWith('/electronic-field-map/fields');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
